import { OrderItem } from "../model-order";

export enum ActionEditorKind {
  AddItem,
  AddModifier,
  AddCharge,
  EditDelivery,
  RemoveCharge,
  EditCharge,
  EditTip,
  EditService,
  ChangeItemQuantity,
  EditOrderType,
  EditDeliveryAddress,
  EditOrderTime,
  EditDiscount,
}

export type ActionEditor =
  | { kind: ActionEditorKind.AddItem }
  | { kind: ActionEditorKind.AddModifier; cartItemId: number; itemName: string }
  | { kind: ActionEditorKind.ChangeItemQuantity; cartItemId: number; cartItem: OrderItem }
  | { kind: ActionEditorKind.EditTip }
  | { kind: ActionEditorKind.EditDelivery }
  | { kind: ActionEditorKind.EditDiscount }
  | { kind: ActionEditorKind.EditService }
  | { kind: ActionEditorKind.AddCharge }
  | { kind: ActionEditorKind.RemoveCharge; chargeId: number }
  | { kind: ActionEditorKind.EditCharge; chargeId: number }
  | { kind: ActionEditorKind.EditOrderType }
  | { kind: ActionEditorKind.EditOrderTime }
  | { kind: ActionEditorKind.EditDeliveryAddress }
